@let memberDataValue = memberData();

<rt-dialog-header
  [heading]="'tlc.members.invite_existing_member_for_preonboarding_dialog.heading' | translate"
  [subheading]="
    'tlc.members.invite_existing_member_for_preonboarding_dialog.subheading' | translate
  "
/>

<rt-dialog-body variant="white">
  <form [formGroup]="formGroup" class="form-container">
    @if (memberDataValue) {
      @if (memberDataValue.personalEmail) {
        <ng-container *ngTemplateOutlet="memberDetails; context: { member: memberDataValue }" />
      } @else {
        <div class="advanced-form">
          <ng-container *ngTemplateOutlet="memberDetails; context: { member: memberDataValue }" />
          <rt-infobox
            class="infobox"
            type="information"
            [isDismissible]="false"
            iconName="info-outline"
            [heading]="
              'tlc.members.invite_existing_member_for_preonboarding_dialog.infobox.heading'
                | translate
            "
          >
            <span>{{
              'tlc.members.invite_existing_member_for_preonboarding_dialog.infobox.heading'
                | translate
            }}</span>
          </rt-infobox>
          <div class="controls-container">
            <rt-form-field class="email-field" [required]="true">
              <rt-label
                >{{
                  'tlc.members.invite_existing_member_for_preonboarding_dialog.form.personal_email.label'
                    | translate
                }}
              </rt-label>
              <rt-input
                [rtFormError]="emailFieldErrors"
                [placeholder]="
                  'tlc.members.invite_existing_member_for_preonboarding_dialog.form.personal_email.placeholder'
                    | translate
                "
                formControlName="personalEmail"
                type="email"
                rtProtectedControl
              />
            </rt-form-field>
            <rt-form-field class="first-name-field">
              <rt-label
                >{{
                  'tlc.members.invite_existing_member_for_preonboarding_dialog.form.first_name.label'
                    | translate
                }}
              </rt-label>
              <rt-input
                [placeholder]="
                  'tlc.members.invite_existing_member_for_preonboarding_dialog.form.first_name.placeholder'
                    | translate
                "
                formControlName="firstName"
                rtProtectedControl
              />
            </rt-form-field>
            <rt-form-field class="last-name-field">
              <rt-label
                >{{
                  'tlc.members.invite_existing_member_for_preonboarding_dialog.form.last_name.label'
                    | translate
                }}
              </rt-label>
              <rt-input
                [placeholder]="
                  'tlc.members.invite_existing_member_for_preonboarding_dialog.form.last_name.placeholder'
                    | translate
                "
                formControlName="lastName"
                rtProtectedControl
              />
            </rt-form-field>
          </div>
        </div>
      }
    } @else {
      <rt-spinner />
    }
  </form>
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    variant="primary"
    [loading]="loading()"
    [disabled]="formGroup.invalid"
    (click)="submit()"
    >{{ 'tlc.common.continue' | translate }}
  </rt-button>
</rt-dialog-footer>

<ng-template #memberDetails let-member="member">
  <div class="basic-form">
    <rt-avatar
      [type]="!!member.avatarThumbUrl ? 'image' : 'initials'"
      [imageSrc]="member.avatarThumbUrl ?? null"
      [fullName]="fullName()"
      size="small"
      context="admin"
    />
    <div class="details-container">
      <span class="name">{{ fullName() }}</span>
      <span class="email">{{ member.personalEmail }}</span>
    </div>
  </div>
</ng-template>
